<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)"/>
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col cols="12" md="8" xl="10" sm="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    block
                    @click="changeAction(2)"
                    v-if="$utilFront.withPermission($prm.ADD_SPECIALITY)"
                  >
                    <v-icon left>mdi-plus</v-icon> Nueva especialidad
                  </v-btn>
                </template>
                <span>Agregar especialidad</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.actions`]="{ item }">
             

                      <v-tooltip
                    top
                    v-if="$utilFront.withPermission($prm.UPDATE_SPECIALITY)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon @click="checkSpeciality(item)" x-small>
                        <v-icon color="blue" v-bind="attrs" v-on="on">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar información</span>
                  </v-tooltip>
             
                   <v-tooltip top 
                    v-if="$utilFront.withPermission($prm.DELETE_SPECIALITY)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-small @click="openDialogDelete(item)">
                          <v-icon color="error" v-bind="attrs" v-on="on">
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                  </v-tooltip>
              
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2) || showAction(3)"/>
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de especialidad"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="100"
                      :error-messages="errors"
                      label="Nombre de Especialidad"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <!-- <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Clave presupuestal"
                    rules="required|max:12"
                  >
                    <v-text-field
                      v-model="dataModal.budgetKey"
                      :counter="12"
                      :error-messages="errors"
                      label="Clave presupuestal"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col> -->
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            {{ dialogs.title }}
          </v-card-title>
          <v-card-text>{{ dialogs.text }} </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                dialog = false;
                changeStatus();
              "
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar la especialidad?
          </v-card-title>
          <v-card-text>
            <strong>Especialidad: </strong> {{ model.name }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialogDelete()">
              Cancelar
            </v-btn>
            <v-btn color="primary" text @click="deleteSpeciality()" :disabled="sending">
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import { SpecialityRequest } from "@/core/request";
import AutoLogout from "../../components/AutoLogout.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import Loader from "../../components/Loader.vue";
setInteractionMode("eager");

export default {
  name: "Especialidades",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
  },
  data() {
    return {
      dialog: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: {
        icono: "mdi-arrange-bring-to-front",
        texto: "Especialidades",
      },
      list: [],
      sending: false,
      dialogs: {
        title: "¿Desea cambiar el estatus de la especialidad?",
        text: "La especialidad será habilitada / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
      },
      headers: [
        { text: "Id Especialidad", value: "idSpeciality", align:"center", width:"20%" },
        { text: "Nombre", value: "name", align:"center" },
        { text: "Acciones", value: "actions", sortable: false , align:"center"},
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Especialidad",
        tooltip: "Agregar Especialidad",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar especialidad",
      service: SpecialityRequest,
      dialogDelete: false,
      model: {}
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-arrange-bring-to-front",
            texto: "Especialidades",
          };
          this.dialogs = {
            title: "¿Desea cambiar el estatus de la especialidad?",
            text: "La especialidad será habilitada / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-arrange-bring-to-front",
            texto: "Registrar especialidad",
          };
          this.dialogs = {
            title: "¿Desea registrar ésta especialidad?",
            text: "La especialidad será registrada de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar especialidad";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-arrange-bring-to-front",
            texto: "Editar especialidad",
          };
          this.dialogs = {
            title: "¿Desea modificar ésta especialidad?",
            text: "La especialidad será modificada de inmediato y podría afectar a los registros que dependan de ella",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar especialidad";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-arrange-bring-to-front",
            texto: "Especialidades",
          };
          break;
      }
    },
    doAction() {
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    listAll() {
      SpecialityRequest.allSpeciality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((speciality) => {
            return {
              idSpeciality: speciality.idSpeciality,
              name: speciality.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if(!this.sending){
      let postData = {
        name: this.dataModal.name.trim(),
      };
      this.sending = true;
      SpecialityRequest.addSpeciality(postData)
        .then((res) => {
          if (/*res.data.code === 200 &&*/ res.data.response === true) {
            this.$utilFront.notifications(
              "Especialidad registrada correctamente",
              "SUCCESS"
            );
            this.listAll();
            this.changeAction(1);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(res.data.message, "ERROR");
          }
        })
        .finally(() => {
          this.sending = false;
        });
      }
    },
    update() {
      if(!this.sending){
      let postData = {
        idSpeciality: this.dataModal.idSpeciality,
        name: this.dataModal.name.trim(),
      };
      this.sending = true;
      SpecialityRequest.updateSpeciality(postData)
        .then((res) => {
          if (res.data.response === true) {
            this.$utilFront.notifications(
              "Especialidad modificada correctamente",
              "SUCCESS"
            );
            this.listAll();
            this.changeAction(1);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(res.data.message, "ERROR");
          }
        })
        .finally(() => {
          this.sending = false;
        });
      }
    },
    checkSpeciality(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.changeAction(3);
    },
    openDialogDelete(item){
      this.model = Object.assign(this.model, item);
      this.dialogDelete = true;
    },
    closeDialogDelete(){
      this.model = Object.assign(this.model, {});
      this.dialogDelete = false;
    },
    deleteSpeciality(){
      
      this.sending = true;
      let params = { idSpeciality: this.model.idSpeciality};

      SpecialityRequest.deleteSpeciality(params).then((res) => {

          let {data, code, status} = res.data;

          if(code == 200 && data == true){
              this.closeDialogDelete();
              this.listAll();
              this.$utilFront.notifications( "Especialidad eliminada.", "SUCCESS" );
          }else{
            this.$utilFront.notifications("El registro cuenta con dependencias.","ERROR");
          }
          
      }).catch(this.$utilFront.errorhttp).finally(() => {
        this.sending = false;
      });
    }
  },
};
</script>